import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["swiper"]

  connect() {
    import("swiper").then(({ default: SwiperCore, Pagination, Navigation }) => {
      SwiperCore.use([Pagination, Navigation])

      import("swiper").then(({ default: Swiper }) => {
        new Swiper(".swiper-container", {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          spaceBetween: 30,
          speed: 500,
          loop: true,
          navigation: {
            nextEl: ".wide-slider__next",
            prevEl: ".wide-slider__prev",
          },
        })
      })
    })
  }
}
